import Vue from 'vue'
import FormJSON from './vuetify-formjson'

window.ExtraFormJSONComponents = {
    'vf-product-card-input': () => import(/* webpackChunkName: "product-card"*/ './custom-components/ProductCard.vue'),
    'vf-current-cart-input': () => import(/* webpackChunkName: "current-cart"*/ './custom-components/CurrentCart.vue'),
    'vf-login-card-input': () => import(/* webpackChunkName: "login-card"*/ './custom-components/LoginCard.vue'),
    'vf-timer-card-input': () => import(/* webpackChunkName: "timer-card"*/  './custom-components/TimerCard.vue'),
    'vf-app-content': () => import(/* webpackChunkName: "app-content"*/  './custom-components/Content.vue'),
    'vf-product-childrens-card-input': () => import(/* webpackChunkName: "product-childrens-card1"*/  './custom-components/ProductChildrensCard.vue'),
    'vf-support-card-input': () => import(/* webpackChunkName: "support-card"*/ './custom-components/SupportCard.vue'),
    'vf-cart-history-input': () => import(/* webpackChunkName: "cart-history"*/ './custom-components/CartHistory.vue'),
    'vf-product-video-link-input': () => import(/* webpackChunkName: "video-link"*/ './custom-components/ProductVideoLink.vue'),
    'vf-video-player-input': () => import(/* webpackChunkName: "video-player"*/ './custom-components/VideoPlayer.vue'),
    'vf-livesstream-input': () => import(/* webpackChunkName: "live-window"*/ './custom-components/LivestreamWindow.vue'),
    'vf-azmoon-input': () => import(/* webpackChunkName: "azmoon-window"*/ './custom-components/AzmoonWindow.vue'),
    'vf-product-download-link-input': () => import(/* webpackChunkName: "product-download-link1"*/ './custom-components/ProductDownloadLink.vue'),
    'vf-ac-session-link-input': () => import(/* webpackChunkName: "ac-session-link"*/ './custom-components/AcSessionLink.vue'),
    'vf-image-input': () => import(/* webpackChunkName: "image-input"*/ './custom-components/ImageInput.vue'),
    'vf-week-calendar-input': () => import(/* webpackChunkName: "week-calendar-input"*/ './custom-components/WeekCalendar.vue'),
    'vf-rev-slider-input': () => import(/* webpackChunkName: "rev-slider"*/ './custom-components/RevSlider.vue'),
    'vf-introducers-history-input': () => import(/* webpackChunkName: "intros-history"*/ './custom-components/IntroducersHistory.vue'),
    'vf-wallet-transactions-history-input': () => import(/* webpackChunkName: "walet-history"*/ './custom-components/WalletTransactionsHistory.vue'),
    'vf-single-login-card-input': () => import(/* webpackChunkName: "single-login-card" */ './custom-components/SingleLoginCard.vue'),
    'vf-add-credit-input': () => import(/* webpackChunkName: "extra-gift-code-link"*/ './custom-components/AddCreditCard.vue'),
    // extra non json builder components working stand alone
    'object-links-card': () => import(/* webpackChunkName: "extra-object-link"*/ './custom-components/Extras/ObjectLinksCard.vue'),
    'user-links-card': () => import(/* webpackChunkName: "extra-user-link"*/ './custom-components/Extras/UserLinksCard.vue'),
    'product-links-card': () => import(/* webpackChunkName: "extra-product-link"*/ './custom-components/Extras/ProductLinksCard.vue'),
    'form-entry-links-card': () => import(/* webpackChunkName: "extra-form-link"*/ './custom-components/Extras/FormEntryLinksCard.vue'),
    'gift-codes-links-card': () => import(/* webpackChunkName: "extra-gift-code-link"*/ './custom-components/Extras/GiftCodeLinksCard.vue'),
}

import ProductCardSettings from './custom-components/settings/ProductCard'
import CurrentCartSettings from './custom-components/settings/CurrentCart'
import TimerCardSettings   from './custom-components/settings/TimerCard'
import ProductChildrensCardSettings from './custom-components/settings/ProductChildrensCard'
import LoginCardSettings from './custom-components/settings/LoginCard'
import SupportCardSettings from './custom-components/settings/SupportCard'
import CartHistorySettings from './custom-components/settings/CartHistory'
import ProductDownloadLinkSettings from './custom-components/settings/ProductDownloadLink'
import ProductVideoLinkSettings from './custom-components/settings/ProductVideoLink'
import VideoPlayerSettings from './custom-components/settings/VideoPlayer'
import LiveStreamWindowSettings from './custom-components/settings/LiveStreamWindow'
import ACSessionLinkSettings from './custom-components/settings/AcSessionLink'
import ImageInputSettings from './custom-components/settings/ImageInput'
import WeekCalendarSettings from './custom-components/settings/WeekCalendar'
import RevSliderSettings from './custom-components/settings/RevSlider'
import IntroducersHistorySettings from './custom-components/settings/IntroducersHistory'
import WalletTransactionsHistorySettings from './custom-components/settings/WalletTransactionsHistory'
import AzmoonWindowSettings from './custom-components/settings/AzmoonWindow'
import SingleLoginCardSettings from './custom-components/settings/SingleLoginCard'
import AddCreditCardSettings from './custom-components/settings/AddCreditCard'

window.ExtraFormJSONSettings = {
    'vf-product-card-input': new ProductCardSettings(),
    'vf-current-cart-input': new CurrentCartSettings(),
    'vf-timer-card-input': new TimerCardSettings(),
    'vf-product-childrens-card-input': new ProductChildrensCardSettings(),
    'vf-support-card-input': new SupportCardSettings(),
    'vf-login-card-input': new LoginCardSettings(),
    'vf-cart-history-input': new CartHistorySettings(),
    'vf-product-video-link-input': new ProductVideoLinkSettings(),
    'vf-product-download-link-input': new ProductDownloadLinkSettings(),
    'vf-video-player-input': new VideoPlayerSettings(),
    'vf-livesstream-input': new LiveStreamWindowSettings(),
    'vf-azmoon-input': new AzmoonWindowSettings(),
    'vf-image-input': new ImageInputSettings(),
    'vf-week-calendar-input': new WeekCalendarSettings(),
    'vf-rev-slider-input': new RevSliderSettings(),
    'vf-introducers-history-input': new IntroducersHistorySettings(),
    'vf-wallet-transactions-history-input': new WalletTransactionsHistorySettings(),
    'vf-single-login-card-input': new SingleLoginCardSettings(),
    'vf-add-credit-input': new AddCreditCardSettings(),
};

for (const name in window.ExtraFormJSONComponents) {
    if (Object.prototype.hasOwnProperty.call(window.ExtraFormJSONComponents, name)) {
        Vue.component(name, window.ExtraFormJSONComponents[name]);
    }
}

Vue.use(FormJSON);
